import React, { useState } from 'react';
import { Box, InputAdornment, Stack, Tab, Tabs, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Grid from '@mui/material/Grid2';
import useToast from '../../../../hooks/useToast';
import CusSwitch from '../../../material-ui/CusSwitch';
import CusInput from '../../../material-ui/CusInput';

export default function LangAndLink({
  languages,
  defaultLanguage,
  setDefaultLanguage,
  languageFields,
  changeLanguages
}) {
  const { t } = useTranslation();
  const { infoToast } = useToast();
  const [activeTab, setActiveTab] = useState(languages[0].value);

  const handleChange = (_, newValue) => setActiveTab(newValue);

  const sizeInput = 6;

  const choseLang = languages?.find((el) => el.value == activeTab)?.lang;
  const choseField = languageFields?.[choseLang] || {};

  return (
    <Box>
      <Box mt={1} sx={{ backgroundColor: (theme) => theme.palette.grey[100] }}>
        <Tabs value={activeTab} onChange={handleChange} variant="scrollable" scrollButtons="auto">
          {languages.map((tab) => {
            return (
              <Tab
                label={t(tab.label)}
                sx={{ minHeight: '50px' }}
                value={tab.value}
                key={tab.lang}
              />
            );
          })}
        </Tabs>
      </Box>
      <Box mt={2}>
        <Grid container spacing={1}>
          <Grid size={12}>
            <Stack display={'flex'} direction={'row'} gap={2}>
              <Box>
                <Stack display={'flex'} direction="row" alignItems="center">
                  <CusSwitch
                    label={'Enabled'}
                    checked={choseField.enabled}
                    onChange={() => {
                      if (activeTab == defaultLanguage) {
                        infoToast(
                          'You cannot turn off a language if it is enabled as the "Default Language".'
                        );
                        return;
                      }
                      changeLanguages('enabled', !choseField.enabled, choseLang);
                    }}
                  />
                  <CusSwitch
                    label={'Default language'}
                    checked={activeTab == defaultLanguage}
                    onChange={() => {
                      changeLanguages('enabled', true, choseLang);
                      setDefaultLanguage(activeTab);
                      const textTurnOf =
                        'Turn On a different default language and it will be turned off automatically here!';

                      if (activeTab == defaultLanguage) infoToast(textTurnOf);
                    }}
                  />
                </Stack>
              </Box>
            </Stack>
          </Grid>

          <Grid size="grow" container spacing={1}>
            <Grid size={sizeInput}>
              <CusInput
                value={choseField.channelLink || ''}
                label={'Telegram channel casino'}
                placeholder={' https://t.me/some_channel'}
                onChange={(e) => changeLanguages('channelLink', e.target.value, choseLang)}
              />
            </Grid>
            <Grid size={sizeInput}>
              <CusInput
                value={choseField.postLink || ''}
                label={'Telegram post for a gaming website'}
                placeholder={' https://t.me/some_channel/some_public_post'}
                onChange={(e) => changeLanguages('postLink', e.target.value, choseLang)}
              />
            </Grid>
            <Grid size={sizeInput}>
              <CusInput
                value={choseField.reviewLink || ''}
                label={'Reviews on the Telegram channel'}
                placeholder={' https://t.me/some_review_channel'}
                onChange={(e) => changeLanguages('reviewLink', e.target.value, choseLang)}
              />
            </Grid>
            <Grid size={sizeInput}>
              <CusInput
                label={'Telegram technical support chat'}
                placeholder={'nickname_of_support'}
                value={choseField.supportChat || ''}
                startAdornment={
                  <InputAdornment sx={{ m: 0 }} position="start">
                    <Typography lineHeight={'100%'}>@</Typography>
                  </InputAdornment>
                }
                onChange={(e) => {
                  const value = e.target.value.replaceAll('@', '');
                  changeLanguages('supportChat', value, choseLang);
                }}
              />
            </Grid>
            <Grid size={sizeInput}>
              <CusInput
                value={choseField.chatLink || ''}
                label={'Casino Telegram Chat'}
                placeholder={' https://t.me/some_telegram_chat'}
                onChange={(e) => changeLanguages('chatLink', e.target.value, choseLang)}
              />
            </Grid>
            <Grid size={sizeInput}>
              <CusInput
                value={choseField.supportEmail || ''}
                label={'Technical support email'}
                placeholder={'support@example.tld'}
                onChange={(e) => changeLanguages('supportEmail', e.target.value, choseLang)}
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
